// extracted by css-extract-rspack-plugin
export default {"container":"InlineAutocomplete-module__container__gc8Yc3D","fullWidth":"InlineAutocomplete-module__fullWidth__oLjjKdG"};